import React, { useEffect } from 'react';
import {
  FaRocket,
  FaPenFancy,
  FaFacebookF,
  FaTwitter,
  FaLinkedinIn,
  FaInstagram,
  FaRedditAlien,
  FaCommentDots,
  FaYoutube,
  FaMediumM,
  FaDev,
  FaMagic,
 FaBrain,
 FaSave,
 FaStream,

} from 'react-icons/fa';
import SeoHelmet from './SeoHelmet';
import MonoButton from '../kits/DesignKit/MonoButton';
import { ZenPostHeroSection, ZenPostWorkflowSection, ZenPostPricingSection, ZenPostOllamaSection, ZenPostDocStudioSection, ZenPostDocStudioFeatureSection, ZenPostDocStudioPriceCards, ZenPostHeroScreenshot } from './ZenPostSections';

const ZenPostStudioLandingPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const trackCTA = (ctaName) => {
    if (window.gtag) {
      window.gtag('event', 'cta_click', {
        event_category: 'ZenPostStudio',
        event_label: ctaName
      });
    }
    console.log(`CTA Clicked: ${ctaName}`);
  };

  const stats = [
    { label: 'Plattformen', value: '9' },
    { label: 'KI-Modelle', value: 'Lokal' },
    { label: 'Offline-fähig', value: 'Ja' },
    { label: 'Basisversion', value: '0€' }
  ];

  const platforms = [
    { name: 'Facebook', description: 'Long-Form Posts mit optimalem Format', icon: <FaFacebookF /> },
    { name: 'X (Twitter)', description: 'Thread-Support mit Zeichen-Optimierung', icon: <FaTwitter /> },
    { name: 'LinkedIn', description: 'Business-Ton & klare Struktur', icon: <FaLinkedinIn /> },
    { name: 'Instagram', description: 'Captions & Hashtags für Reichweite', icon: <FaInstagram /> },
    { name: 'Reddit', description: 'TL;DR & Subreddit-Vorschläge', icon: <FaRedditAlien /> },
    { name: 'Threads', description: 'Conversation-Ready Posts', icon: <FaCommentDots /> },
    { name: 'YouTube', description: 'Titel, Beschreibung & Shorts-Teaser', icon: <FaYoutube /> },
    { name: 'Medium', description: 'Publizieren mit passender Struktur', icon: <FaMediumM /> },
    { name: 'dev.to', description: 'Developer-Optimierung inklusive Tags', icon: <FaDev /> }
  ];

  const features = [
      {
        icon: <FaMagic className="text-brand text-2xl animate-spin [animation-duration:6s]" />,
        title: "Transformation",
        description: "Wandle jeden Artikel sofort in 9+ Plattform Posts um.",
     
      },
      {
        icon: <FaBrain className="text-brand text-2xl animate-spin [animation-duration:6s]" />,
        title: "Plattform-Optimiert",
        description: "Automatische Anpassung an Ton, Länge & Format.",
      
      },
      {
        icon: <FaSave className="text-brand text-2xl animate-spin [animation-duration:6s]" />,
        title: "Lokale Dokumente",
        description: "Relevante Ablage auf deinem Desktop für maximale Sicherheit.",
 
      },
      {
        icon: <FaStream className="text-brand text-2xl animate-spin [animation-duration:6s]" />,
        title: "Data Room",
        description: "Erstelle echte Dokumente für deine Projekte.",
        
      }
    ];

  const workflowSteps = [
    {
      title: 'schreiben oder import',
      description: 'Nutze ZenEditor oder importiere bestehende Blogposts.'
    },
    {
      title: 'Plattformen auswählen',
      description: 'Wähle die Kanäle für deine Inhalte in Sekunden.'
    },
    {
      title: 'Posts generieren',
      description: 'KI erstellt Plattform-optimierte Varianten automatisch.'
    },
    {
      title: 'Feinschliff & teilen',
      description: 'Passe Details an, kopiere oder publiziere direkt.'
    }
  ];

  const pricingPlans = [
    {
      name: 'ZenPost Studio Free',
      price: 'Kostenlos',
      emoji: '✍️',
      icon: <FaPenFancy className="text-brand" />,
      description: 'Reines Schreiben im Web oder als Desktop-App',
      features: [
        'Reines Schreiben (Web oder Desktop)',
        'Lokale KI mit Ollama (optional)',
        'Lokale Datenspeicherung',
        'Kein Publisher',
        'Kein Doc Studio',
        '100% Offline',
        'Unbegrenzte Nutzung'
      ],
      cta: 'ZenPost Studio starten',
      popular: false,
      ctaAction: () => {
        trackCTA('Pricing_Live_Demo');
       window.open("https://zenpost.denisbitter.de", "_blank", "noopener,noreferrer");
      }
    },
    {
      name: 'ZenPost Studio Pro',
      price: '79€',
      period: '/Lifetime',
      emoji: '🚀',
      icon: <FaRocket className="text-brand" />,
      description: 'Web + Desktop + 5 KI Modelle API  + Doc Studio',
      features: [
        'Alles aus Free',
        'Datei Projekt Management',
        'Posting Planner und Schedule',
        'API Key Integration',
        'Analytics & Insights',
        'Custom Templates',
        'Publisher 9+ Medium, LinkedIn 7+ mehr',
        'Versionierung & History',
        'API-Zugriff (Supreme)',
        'Doc Studio mit HardScan',
        'KI Anbindung 5+'
      ],
      cta: 'ZenPost Studio Pro Starten',
      popular: true,
      ctaAction: () => {
        trackCTA('Pricing_Pro_Anfragen');
       window.open("https://zenpost.denisbitter.de", "_blank", "noopener,noreferrer")
      }
    }
  ];

  const faqs = [
    {
      q: 'Welche Plattformen unterstützt ZenPost Studio?',
      a: 'Aktuell optimiert für LinkedIn, X, Instagram, Reddit, Threads und Facebook. Weitere Plattformen folgen.'
    },
    {
      q: 'Kann ich die generierten Posts anpassen?',
      a: 'Ja. Du kannst jede Version bearbeiten, kürzen oder erweitern, bevor du sie veröffentlichst.'
    },
    {
      q: 'Wie funktioniert die lokale KI?',
      a: 'ZenPost Studio nutzt Ollama, damit deine Texte lokal auf deinem Gerät verarbeitet werden. Keine Cloud, keine API-Kosten.'
    },
    {
      q: 'Ist ZenPost Studio wirklich kostenlos?',
      a: 'Ja. ZenPost Studio bleibt dauerhaft kostenlos und ist komplett offline nutzbar.'
    },
    {
      q: 'Kann ich mehrere Artikel auf einmal umwandeln?',
      a: 'Mit ZenPost Studio Pro kannst du mehrere Inhalte parallel vorbereiten, verwalten und Transformieren auf 9+ Plattformen gleichzeitig'
    }
  ];

  return (
    <>
      <SeoHelmet
        title="ZenPost Studio – Schreiben, Dokumentieren, Publizieren"
        description="ZenPost Studio: Schreibe einmal, erstelle Posts für verschiedene Plattformen. Inklusive Doc Studio für Projekt-Dokumentation. Kostenlose Desktop-App mit lokaler KI."
        keywords="zenpost studio, schreiben, dokumentation, lokale ki, ollama, markdown editor, doc studio"
        ogImage="/images/zenpoststudio-og.jpg"
      />

      <div
        className="min-h-screen text-white font-mono"
        style={{
          background: 'linear-gradient(180deg, #0B0B0B 0%, #121212 50%, #151515 100%)'
        }}
      >
              <ZenPostHeroSection
          eyebrow="Schreiben & Publizieren"
          title="Einmal Schreiben,"
          titleAccent="9+ Transformieren"
          subtitle="Schreibe einmal und erstelle daraus optimierte Posts für 9 Plattformen. Inklusive Doc Studio für README, Changelog und Projekt-Dokumentation."
          miniText="Doc Studio: Project Context Wizard, automatische Projektanalyse, strukturierte Dokumentation."
          primaryCtaText="ZenStudio testen"
          onPrimaryCta={() => window.open("https://zenpost.denisbitter.de", "_blank", "noopener,noreferrer")}
          secondaryCtaText="9 Plattformen"
          onSecondaryCta={() =>
            document.getElementById("platforms")?.scrollIntoView({ behavior: "smooth" })
          }
          primaryUnderline="pink"
          secondaryUnderline="gray"
          stats={stats}
        />

        {/* Hero Screenshot */}
        <ZenPostHeroScreenshot
          src="/images/zenpoststudio/ZenPost_01_willkommen.png"
          alt="ZenPost Studio Startbildschirm"
        />


<ZenPostDocStudioSection
  title="Dokumentation"
  titleAccent="aus Code + Kontext"
  subtitle="ZenStudio analysiert dein Projekt und generiert daraus strukturierte Dokumentation."
  bullets={[
    "Project Context Wizard erfasst Grundlagen",
    "Automatische Projektstruktur-Erkennung",
    "Strukturierte Dokumentation mit klaren TODOs"
  ]}
  onPrimaryCta={() => window.location.href = "/dashboard?docstudio=true"}
  onSecondaryCta={() =>
    document.getElementById("workflow")?.scrollIntoView({ behavior: "smooth" })
  }
/>
    {/* doku Screenshot */}
        <ZenPostHeroScreenshot
          src="/images/zenpoststudio/zenPostDocStudio_DocTemplates.png"
          alt="ZenPost Studio Startbildschirm"
        />

<ZenPostDocStudioFeatureSection />

        <section id="platforms" className="py-16 sm:py-20 px-4 bg-[transparent] ">
          <div className="max-w-6xl mx-auto text-center ">
            <div className="inline-flex items-center rounded-full border border-brand px-3 py-1 text-xs  text-[#e6dbca]">
              Content AI Studio
            </div>
            <h2 className="mt-4 text-3xl sm:text-4xl md:text-5xl font-extrabold text-brand">
              Ein Artikel, neun Plattformen
            </h2>
            <p className="mt-3 text-base sm:text-lg text-[#e6dbca] max-w-3xl mx-auto">
              Jede Plattform bekommt Inhalte, die zu ihrem Format und ihrer Zielgruppe passen.
            </p>

            <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3 text-left ">
              {platforms.map((platform) => (
                <div
                  key={platform.name}
                  className="rounded-2xl border border-brand bg-transparent p-6 shadow-lg shadow-slate-950/40"
                >
                  <div className="flex h-12 w-12 items-center justify-center rounded-xl border border-brand  text-brand text-xl">
                    {platform.icon}
                  </div>
                  <h3 className="mt-5 text-xl font-semibold text-brand">
                    {platform.name}
                  </h3>
                  <p className="mt-2 text-sm text-[#e6dbca]">
                    {platform.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>



                {/* section Content AI Studio Plattfomen  Features */}
        <section className="py-16 sm:py-20 px-4 bg-[transparent] ">
          <div className="max-w-6xl mx-auto text-center">
            <div className="inline-flex items-center rounded-full border border-brand text-[#e6dbca]
              px-3 py-1 text-xs ">
              Features Content AI Studio
            </div>
            <h2 className="mt-4 text-3xl sm:text-4xl md:text-5xl font-extrabold text-brand">
              Eine einfache Lösung <br/>
                Alles, was man braucht          
            </h2>
            <p className="mt-3 text-base sm:text-lg text-[#e6dbca] max-w-3xl mx-auto">
              Smarte Funktionen, um deine Content-Produktion schneller und konsistenter zu machen.
            </p>

            <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-4 text-left">
              {features.map((feature) => (
                <div
                  key={feature.title}
                  className="rounded-2xl border border-brand  p-6 shadow-xl shadow-slate-500/20"
                >
                  <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-transparent border border-brand text-brand text-xl">
                    {feature.icon}
                  </div>
                  <h3 className="mt-5 text-lg font-semibold text-brand">
                    {feature.title}
                  </h3>
                  <p className="mt-2 text-sm text-[#e6dbca]">
                    {feature.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Plattformen Screenshot */}
        <ZenPostHeroScreenshot
          src="/images/zenpoststudio/Zenpost_plattformenKI.png"
          alt="ZenPost Studio Startbildschirm"
        />

        <ZenPostOllamaSection
          badge="Lokale KI"
          title="KI auf deinem Gerät"
          subtitle="Deine Texte bleiben lokal. Keine Cloud, keine API-Kosten."
          howItWorksTitle="So funktioniert es"
          howItWorksDescription="Installiere Ollama einmal. ZenPost Studio erkennt es automatisch. Die Modelle laufen auf deinem Rechner."
          theme="dark"
        />

        <section className="">
          <ZenPostWorkflowSection
            title="Vier einfache Schritte"
            subtitle="Von Blogpost zu Social Content in Minuten"
            steps={workflowSteps}
            variant="timeline"
          />
        </section>

        <ZenPostPricingSection
          title="Einfaches, transparenter Preis"
          subtitle="Starte kostenlos, wachse mit deinen Aufgaben."
          plans={pricingPlans}
          onCTAClick={(plan) => trackCTA(`Pricing_${plan.name.replace(/\s+/g, '_')}`)}
          showEnterpriseContact={true}
          theme="dark"
        />



        <ZenPostDocStudioPriceCards
  highlight="yearly"
  onSelect={(plan) => {
    // 1) simplest: zu deiner App / Pricing Modal springen
    // window.open("https://zenpost.denisbitter.de", "_blank", "noopener,noreferrer");

    // 2) oder: direkt in dein App-Upgrade flow (wenn du route/query hast)
    window.open(
      `https://zenpost.denisbitter.de?upgrade=docstudio&plan=${plan.key}`,
      "_blank",
      "noopener,noreferrer"
    );
  }}
/>

        {/* Screenshot Galerie */}
        <section className="py-16 sm:py-20 px-4 bg-[transparent]">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-10">
              <div className="inline-flex items-center rounded-full border border-brand px-3 py-1 text-xs text-[#e6dbca]">
                Die App
              </div>
              <h2 className="mt-4 text-3xl sm:text-4xl font-extrabold text-brand">
                So sieht es aus
              </h2>
              <p className="mt-3 text-base sm:text-lg text-[#e6dbca] max-w-2xl mx-auto">
                Minimalistisch. Fokussiert. Ohne Ablenkung.
              </p>
            </div>

            <div className="grid md:grid-cols-2 gap-6 items-stretch">
              <div className="rounded-2xl border border-brand/30 overflow-hidden shadow-xl flex flex-col group">
                <div className="flex-grow flex items-center justify-center bg-[#0d0d0d] overflow-hidden">
                  <img
                    src="/images/zenpoststudio/ZenPost_01_willkommen.png"
                    alt="ZenPost Studio - Startbildschirm"
                    className="w-full h-auto transition-transform duration-300 group-hover:scale-110"
                  />
                </div>
                <div className="p-4 bg-transparent">
                  <p className="text-sm text-[#e6dbca]">Startbildschirm mit Studio-Auswahl</p>
                </div>
              </div>
              <div className="rounded-2xl border border-brand/30 overflow-hidden shadow-xl flex flex-col group">
                <div className="flex-grow flex items-center justify-center bg-[#0d0d0d] overflow-hidden">
                  <img
                    src="/images/zenpoststudio/ZenPost_02_editor.png"
                    alt="ZenPost Studio - Editor"
                    className="w-full h-auto transition-transform duration-300 group-hover:scale-110"
                  />
                </div>
                <div className="p-4 bg-transparent">
                  <p className="text-sm text-[#e6dbca]">Editor mit Markdown-Unterstützung</p>
                </div>
              </div>
              <div className="rounded-2xl border border-brand/30 overflow-hidden shadow-xl flex flex-col group">
                <div className="flex-grow flex items-center justify-center bg-[#0d0d0d] overflow-hidden">
                  <img
                    src="/images/zenpoststudio/ZenPost_PlannerToolfuerneuePost.png"
                    alt="ZenPost Studio - Planner"
                    className="w-full h-auto transition-transform duration-300 group-hover:scale-110"
                  />
                </div>
                <div className="p-4 bg-transparent">
                  <p className="text-sm text-[#e6dbca]">Planner für neue Posts</p>
                </div>
              </div>
              <div className="rounded-2xl border border-brand/30 overflow-hidden shadow-xl flex flex-col group">
                <div className="flex-grow flex items-center justify-center bg-[#0d0d0d] overflow-hidden">
                  <img
                    src="/images/zenpoststudio/zenPostDocStudio_DocTemplates.png"
                    alt="ZenPost Studio - Doc Templates"
                    className="w-full h-auto transition-transform duration-300 group-hover:scale-110"
                  />
                </div>
                <div className="p-4 bg-transparent">
                  <p className="text-sm text-[#e6dbca]">Doc Studio mit Templates</p>
                </div>
              </div>

            {/* Platform Pictures*/}
  <div className="rounded-2xl border border-brand/30 overflow-hidden shadow-xl flex flex-col group">
                <div className="flex-grow flex items-center justify-center bg-[#0d0d0d] overflow-hidden">
                  <img
                    src="/images/zenpoststudio/Zenpost_plattformenKI.png"
                    alt="ZenPost Studio - Doc Templates"
                    className="w-full h-auto transition-transform duration-300 group-hover:scale-110"
                  />
                </div>
                <div className="p-4 bg-transparent">
                  <p className="text-sm text-[#e6dbca]">Content Studio AI Plattformen</p>
                </div>
              </div>


              {/* Platform Pictures*/}
  <div className="rounded-2xl border border-brand/30 overflow-hidden shadow-xl flex flex-col group">
                <div className="flex-grow flex items-center justify-center bg-[#0d0d0d] overflow-hidden">
                  <img
                    src="/images/zenpoststudio/Zenpost_export_plattformen.png"
                    alt="ZenPost Studio - Doc Templates"
                    className="w-full h-auto transition-transform duration-300 group-hover:scale-110"
                  />
                </div>
                <div className="p-4 bg-transparent">
                  <p className="text-sm text-[#e6dbca]">Export Transformationen</p>
                </div>
              </div>

            </div>
          </div>
        </section>

        <section className="py-16 sm:py-20 px-4 bg-[transparent]">
          <div className="max-w-5xl mx-auto text-center">
            <div className="inline-flex items-center rounded-full border border-brand
              px-3 py-1 text-xs  text-[#e6dbca]">
              FAQ
            </div>
            <h2 className="mt-4 text-2xl text-brand sm:text-4xl md:text-5xl font-extrabold">
              Häufige Fragen
            </h2>

            <div className="mt-10 space-y-4 text-left">
              {faqs.map((item) => (
                <details
                  key={item.q}
                  className="rounded-2xl border border-brand  p-5 shadow-lg shadow-slate-950/40"
                >
                  <summary className="cursor-pointer text-base sm:text-sm font-normal text-[#e6dbca]">
                    {item.q}
                  </summary>
                  <p className="mt-3 text-sm sm:text-sm text-slate-900 p-10 rounded-lg  bg-[#EFEBDC]">
                    {item.a}
                  </p>
                </details>
              ))}
            </div>
          </div>
        </section>

        <section className="py-16 sm:py-20 px-4">
          <div className="max-w-5xl mx-auto">
            <div className="rounded-[32px] border border-brand p-8 sm:p-12 text-center shadow-2xl shadow-slate-900">
              <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-lg text-brand text-xl border border-brand">
                <FaRocket />
              </div>
              <h2 className="mt-6 text-3xl sm:text-4xl font-extrabold text-brand">
                Bereit loszulegen?
              </h2>
              <p className="mt-4 text-base sm:text-sm text-[#e6dbca]">
                Weniger Copy-Paste. Mehr Zeit für Inhalte.
              </p>
              <MonoButton
                onClick={() => {
                  trackCTA('Final_CTA');
                  
                  window.open("https://zenpost.denisbitter.de", "_blank", "noopener,noreferrer"); 
                }}
               
                className="mt-8 rounded-full bg-transparent
                 border-brand  px-8 py-3 text-sm 
                 sm:text-base font-semibold text-brand 
                 shadow-sm shadow-brand/40 transition hover:shadow-brand/60"
                underlineColors="ZenBrand"
                textColor='text-brand'
              >
                ZenPost Studio starten
              </MonoButton>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default ZenPostStudioLandingPage;
